import React, { useState, useEffect, useContext } from 'react';
import { Button, Card, Checkbox, FormControl, FormLabel, Grid, Input, List, ListItem, Typography } from '@mui/joy';
import { Save } from '@mui/icons-material';
import Swal from 'sweetalert2';
import { jwtDecode } from 'jwt-decode';
import { get, patch } from '../../../api/api';
import { CLayout } from '../../../components';
import { TitleContext } from '../../../components/Layout';
import '../style.scss';
import { SCOPE_OPTIONS, abonnementSchema } from '../constants'; // chemin à adapter

export const VShowAbonnement: React.FC = () => {
    const { setTitle } = useContext(TitleContext) || {};
    const [id, setId] = useState<string>('');
    const [subscription, setSubscription] = useState<any>({});
    const [selectedScopes, setSelectedScopes] = useState<string[]>([]);

    const handleScopeChange = (scope: string) => {
        setSelectedScopes((prev) =>
            prev.includes(scope) ? prev.filter((s) => s !== scope) : [...prev, scope]
        );
    };

    const handleInputChange = (key: string, value: string) => {
        setSubscription((prev: any) => ({
            ...prev,
            [key]: value,
        }));
    };

    useEffect(() => {
        const query = new URLSearchParams(window.location.search);
        setId(query.get('id') ?? '');

        const token = localStorage.getItem("token") || '';
        const decode: any = jwtDecode(token);
        if (!decode.roles.includes('ROLE_ADMIN')) {
            window.location.href = '/';
        }
    }, []);

    useEffect(() => {
        if (setTitle) {
            setTitle("Détail de l'abonnement");
        }
    }, [setTitle]);

    useEffect(() => {
        if (id) {
            void get({ url: `subscription_plans/${id}` })
                .then((res) => {
                    setSubscription(res.data);
                    setSelectedScopes(res.data.scopes || []);
                })
                .catch((err) => {
                    console.log(err);
                    Swal.fire({
                        icon: 'error',
                        title: 'Erreur',
                        text: "Impossible de récupérer l'abonnement.",
                    });
                });
        }
    }, [id]);

    const submit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const dataObj = Object.fromEntries(formData.entries());

        try {
            await abonnementSchema.validate(dataObj, { abortEarly: false });
            const payload = {
                ...dataObj,
                scopes: selectedScopes,
            };
            console.log(payload);
            await patch({ url: `subscription_plans/${subscription.id}`, data: payload });
            Swal.fire({
                icon: 'success',
                title: 'Succès',
                text: "L'abonnement a été mis à jour avec succès.",
            }).then(() => {
                window.location.href = '/plans';
            });
        } catch (error: any) {
            if (error.name === 'ValidationError') {
                Swal.fire({
                    icon: 'error',
                    title: 'Erreur de validation',
                    text: error.errors.join(', '),
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Erreur',
                    text: "Une erreur est survenue lors de la mise à jour de l'abonnement.",
                });
            }
        }
    };

    return (
        <CLayout>
            <section id="VShowAbonnement">
                <form onSubmit={submit}>
                    <Grid container spacing={2}>
                        <Grid xs={12}>
                            <Card className="cards" sx={{ p: 3, mt: 3 }}>
                                <Grid container spacing={2}>
                                    <Grid xs={12}>
                                        <FormControl>
                                            <FormLabel>Nom</FormLabel>
                                            <Input
                                                name="name"
                                                value={subscription.name || ""}
                                                onChange={(e) => handleInputChange('name', e.target.value)}
                                            />
                                        </FormControl>
                                    </Grid>

                                    <Grid xs={12}>
                                        <FormControl>
                                            <FormLabel>Stripe ID</FormLabel>
                                            <Input
                                                name="stripe_plan_id"
                                                value={subscription.stripe_plan_id || ""}
                                                onChange={(e) => handleInputChange('stripe_plan_id', e.target.value)}
                                            />
                                        </FormControl>
                                    </Grid>

                                    <Grid xs={12}>
                                        <FormLabel>Scopes</FormLabel>
                                        <List>
                                            {SCOPE_OPTIONS.map((scope, key) => (
                                                <ListItem key={key}>
                                                    <Checkbox
                                                        value={scope.id}
                                                        label={scope.name}
                                                        checked={selectedScopes.includes(scope.id)}
                                                        onChange={() => handleScopeChange(scope.id)}
                                                    />
                                                    <Typography level="body-xs" sx={{ ml: 1 }}>
                                                        {scope.description}
                                                    </Typography>
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Grid>

                                    <Grid xs={4} sx={{ ml: 'auto' }}>
                                        <Button type="submit" className="float-right">
                                            <Save sx={{ mr: 1 }} /> Enregistrer
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Card>
                        </Grid>
                    </Grid>
                </form>
            </section>
        </CLayout>
    );
};